import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const TotalGuaranteedToolTip = (props) => (
  <div>
    The number of readers needed to enter a break to satisfy a client’s contract.
  </div>
);

export const CostPerEngagementToolTip = (props) => (
  <div>
    Dollar value client is being charged per engagement.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/breaks-account-information-tool-tips.jsx